/**
 * Cross-Product Links
 *
 * Static registry for cross-product footer links.
 * Add a new product here and every footer updates — like the Hanseatic League,
 * membership benefits all members automatically.
 */

export type ProductLink = {
  id: string
  name: string
  url: string
  tagline: string
}

const allProducts: ProductLink[] = [
  {id: 'narcis', name: 'Narcis.ai', url: 'https://narcis.ai', tagline: 'AI portrait generation'},
  {id: 'quies', name: 'Quies.ai', url: 'https://quies.ai', tagline: 'AI self-hypnosis'},
  {id: 'ovid', name: 'Ovid', url: 'https://ovid.gallery', tagline: 'Maison of the generated image'},
  {id: 'toile', name: 'Toile', url: 'https://toile.pictures', tagline: 'General-purpose image generation'},
]

/** Returns all products except the current one. */
export function getCrossProductLinks(currentProductId: string): ProductLink[] {
  return allProducts.filter((p) => p.id !== currentProductId)
}
